import { Currency } from '@/shared/api';
import { SelectOption } from '@/shared/ui';

import { ICurrency } from '../types';
import { serializeCurrency } from './serialize-currency';

export const serializeCurrenciesSelect = (
  currencies: Currency[],
): SelectOption<ICurrency>[] =>
  currencies.map((currency) => ({
    value: currency.id,
    label: currency.item?.name ?? currency.symbol,
    option: serializeCurrency(currency),
  }));
